import { NIBUTCOLORS } from "./consts";
class Drawcanvas {
  constructor(lang, specs = null, color, circlecnt = 50, data) {
    this._canvas = document.createElement("canvas");

    if (specs) {
      this._canvas.width = specs.width;
      this._canvas.height = specs.height;
    }
    this._size = {
      width: this._canvas.width,
      height: this._canvas.height
    };

    this._ctx = this._canvas.getContext("2d");
    this._circlecnt = circlecnt;
    this.data = data || this.createMockdata();
    this._padding = {
      left: 20,
      top: 20
    };
    this._realDiameter = 8;

    this._ctx.strokeStyle = "white";
    this._ctx.fillStyle = "white";
    this._ctx.save("clear");
    this.clear();
    // this._drawXYAxis()
    this._drawData();
    if (color === "white") {
      var imageData = this._ctx.getImageData(0, 0, this._size.width, this._size.height);
      for (var i = 0; i < imageData.data.length; i += 4) {
        // 当该像素是透明的,则设置成白色
        if (imageData.data[i + 3] === 0) {
          imageData.data[i] = 255;
          imageData.data[i + 1] = 255;
          imageData.data[i + 2] = 255;
          imageData.data[i + 3] = 255;
        }
      }
      this._ctx.putImageData(imageData, 0, 0);
    }
    if (lang) {
      this.$t = lang;
    }
    // BUT影藏模块
    this.carambolaLanguages = [
      "langcfg.txtLipidLayer",
      "langcfg.txtTearHeight",
      "langcfg.txtNibut",
      "langcfg.txtBut",
      "langcfg.txtEyeRedness",
      "langcfg.txtMeiBomian"
    ];
    // 绘制圆形
    // this._circleRect = this._calcCircleRect()
    // this._circle = this._calcCircle()
    // this._scale = this._circle.r * 2 / this._realDiameter
    // this._drawCircle()
  }
  drawCircleRect() {
    this._circleRect = this._calcCircleRect();
    this._circle = this._calcCircle();
    this._scale = (this._circle.r * 2) / this._realDiameter;
    this._drawCircle();
  }
  drawPrintColorBar(x, y, w, h, grade) {
    // _ctx.lineWidth = 0;

    this._ctx.save();
    var gradient = this._ctx.createLinearGradient(x, y, 290, 0);
    gradient.addColorStop(1, "#92ee92");
    gradient.addColorStop(0.4, "#e5ff00");
    gradient.addColorStop(0, "#ec0a0a");
    // 设置填充样式为渐变
    this._ctx.fillStyle = gradient;
    this._ctx.fillRect(x, y, w, h);
    this._ctx.restore();
    grade = grade > 100 ? 100 : grade;
    this.draw(
      (grade < 2 ? x + 3 : grade > 98 ? x - 3 : x) + w * (grade / 100),
      y + 8,
      6,
      0,
      360,
      "blue",
      "stroke",
      true
    );
  }
  draw(x, y, r, start, end, color, type, exist) {
    var unit = Math.PI / 160;
    this._ctx.save();
    this._ctx.beginPath();
    this._ctx[type + "Style"] = color;
    this._ctx.strokeStyle = "blue";
    this._ctx.fillStyle = color;
    // this._ctx.moveTo(x,y)

    this._ctx.arc(x, y, r, start * unit, end * unit);
    if (exist) {
      this._ctx.fill();
    }
    this._ctx.lineWidth = 0;
    this._ctx.closePath();
    this._ctx[type]();
    this._ctx.restore();
  }
  measureCarambolaText(lang, tempxText, tempyText, language) {
    let carambolaLanguagesWidth = [];
    for (let i = 0; i < this.carambolaLanguages.length; i++) {
      carambolaLanguagesWidth.push(this._ctx.measureText(`${lang[i]}`));
    }

    // BUT影藏模块
    for (let j = 0; j < tempxText.length; j++) {
      this._ctx.fillStyle = "#000";
      this._ctx.font = "16px Arial";
      if (j === 0) {
        // 脂质层文字显示
        this._ctx.fillText(this.$t.txtLipidLayer, tempxText[j] + 10, tempyText[j] + 20);
      }
      if (j === 1) {
        // 泪河文字显示
        if (language === "de") {
          this._ctx.fillText(
            this.$t.txtTearHeight,
            tempxText[j] - carambolaLanguagesWidth[j].width + 55,
            tempyText[j]
          );
        } else if (language === "it") {
          this._ctx.fillText(
            this.$t.txtTearHeight,
            tempxText[j] - carambolaLanguagesWidth[j].width + 65,
            tempyText[j] + 5
          );
        } else {
          this._ctx.fillText(
            this.$t.txtTearHeight,
            tempxText[j] - carambolaLanguagesWidth[j].width / 2 + 20,
            tempyText[j]
          );
        }
      }
      if (j === 2) {
        // NIBUT文字显示
        this._ctx.fillText(
          "NIBUT",
          tempxText[j] - carambolaLanguagesWidth[j].width + 40,
          tempyText[j] - 12
        );
      }
      if (j === 3) {
        // But文字显示
        this._ctx.fillText(
          "FBUT",
          tempxText[j] - carambolaLanguagesWidth[j].width + 24,
          tempyText[j] - 14
        );
      }
      if (j === 4) {
        // 眼红文字显示
        if (language === "it") {
          this._ctx.fillText(
            this.$t.txtEyeRedness,
            tempxText[j] - carambolaLanguagesWidth[j].width - 55,
            tempyText[j] + 3
          );
        } else if (language === "de") {
          this._ctx.fillText(
            this.$t.txtEyeRedness,
            tempxText[j] - carambolaLanguagesWidth[j].width + 15,
            tempyText[j]
          );
        } else if (language === "en_US") {
          this._ctx.fillText(
            this.$t.txtEyeRedness,
            tempxText[j] - carambolaLanguagesWidth[j].width / 1.5,
            tempyText[j] + 3
          );
        } else {
          this._ctx.fillText(
            this.$t.txtEyeRedness,
            tempxText[j] - carambolaLanguagesWidth[j].width / 1.5 + 40,
            tempyText[j] + 5
          );
        }
      }
      if (j === 5) {
        // 睑板腺文字显示
        if (language === "it") {
          this._ctx.fillText(
            this.$t.txtMeibomian,
            tempxText[j] - carambolaLanguagesWidth[j].width + 78,
            tempyText[j] + 20
          );
        } else {
          this._ctx.fillText(
            this.$t.txtMeibomian,
            tempxText[j] - carambolaLanguagesWidth[j].width + 98,
            tempyText[j] + 16
          );
        }
      }
    }
    // for (let j = 0; j < tempxText.length; j++) {
    //   this._ctx.fillStyle = '#000'
    //   this._ctx.font = '16px Arial'
    //   if (j === 0) { // 脂质层文字显示
    //     this._ctx.fillText(this.$t.txtLipidLayer, tempxText[j] - carambolaLanguagesWidth[j].width + 84, tempyText[j])
    //   }
    //   if (j === 1) { // 泪河文字显示
    //     this._ctx.fillText(this.$t.txtTearHeight, tempxText[j] - carambolaLanguagesWidth[j].width / 2 + 20, tempyText[j])
    //   }
    //   if (j === 2) { // NIBUT文字显示
    //     this._ctx.fillText('NIBUT', tempxText[j] - carambolaLanguagesWidth[j].width + 30, tempyText[j])
    //   }
    //   if (j === 3) { // 眼红文字显示
    //     this._ctx.fillText(this.$t.txtEyeRedness, tempxText[j] - carambolaLanguagesWidth[j].width / 1.5 + 40, tempyText[j] + 5)
    //   }
    //   if (j === 4) { // 睑板腺文字显示
    //     this._ctx.fillText(this.$t.txtMeibomian, tempxText[j] - carambolaLanguagesWidth[j].width / 3 + 32, tempyText[j] + 5)
    //   }
    // }
  }
  // 画得分雷达线.  参数为中心点X坐标,中心点Y坐标,宽度,数据结果数组
  drawRadarLine(x, y, s, score, exist, language, count) {
    let tempx = []; // 得分折线的X坐标
    let tempy = []; // 得分折线的Y坐标
    let tempxText = []; // 得分折线的X坐标
    let tempyText = []; // 得分折线的Y坐标
    this._ctx.beginPath();
    this._ctx.strokeStyle = "black";

    // BUT影藏模块
    if (score.count < count) {
      console.log("score pram is error");
      // if (score.length < 5) {
      //   console.log('score pram is error')
    } else {
      // BUT影藏模块
      for (let i = 0; i <= count - 1; i++) {
        if (i === 2) {
          tempx[i] = (s / 100) * Math.cos((i * 2 * Math.PI) / count) * score.NIBUT + x; // NIBUT i的Y坐标
          tempy[i] = (-s / 100) * Math.sin((i * 2 * Math.PI) / count) * score.NIBUT + y; // NIBUT的Y坐标
          this.draw(tempx[i], tempy[i], 3, 0, 360, "blue", "stroke", exist.NIBUT);
        } else if (i === 0) {
          tempx[i] = (s / 100) * Math.cos((i * 2 * Math.PI) / count) * score.LipidLayer + x; // LipidLayer i的Y坐标
          tempy[i] = (-s / 100) * Math.sin((i * 2 * Math.PI) / count) * score.LipidLayer + y; // LipidLayer的Y坐标
          this.draw(tempx[i], tempy[i], 3, 0, 360, "blue", "stroke", exist.LipidLayer);
        } else if (i === 1) {
          tempx[i] = (s / 100) * Math.cos((i * 2 * Math.PI) / count) * score.TearHeight + x; // TearHeight i的Y坐标
          tempy[i] = (-s / 100) * Math.sin((i * 2 * Math.PI) / count) * score.TearHeight + y; // TearHeight的Y坐标
          this.draw(tempx[i], tempy[i], 3, 0, 360, "blue", "stroke", exist.TearHeight);
        } else if (i === 3) {
          tempx[i] = (s / 100) * Math.cos((i * 2 * Math.PI) / count) * score.But + x; // But i的Y坐标
          tempy[i] = (-s / 100) * Math.sin((i * 2 * Math.PI) / count) * score.But + y; // But 的Y坐标
          this.draw(tempx[i], tempy[i], 3, 0, 360, "blue", "stroke", exist.But);
        } else if (i === 4) {
          tempx[i] = (s / 100) * Math.cos((i * 2 * Math.PI) / count) * score.EyeRedness + x; // EyeRedness i的Y坐标
          tempy[i] = (-s / 100) * Math.sin((i * 2 * Math.PI) / count) * score.EyeRedness + y; // EyeRedness 的Y坐标
          this.draw(tempx[i], tempy[i], 3, 0, 360, "blue", "stroke", exist.EyeRedness);
        } else if (i === 5) {
          tempx[i] = (s / 100) * Math.cos((i * 2 * Math.PI) / count) * score.MeiBomian + x; // MeiBomian i的Y坐标
          tempy[i] = (-s / 100) * Math.sin((i * 2 * Math.PI) / count) * score.MeiBomian + y; // MeiBomian 的Y坐标
          this.draw(tempx[i], tempy[i], 3, 0, 360, "blue", "stroke", exist.MeiBomian);
        }

        tempxText[i] = (s / 100) * Math.cos((i * 2 * Math.PI) / count + Math.PI / 12) * 110 + x; // score i的X坐标
        tempyText[i] = (-s / 100) * Math.sin((i * 2 * Math.PI) / count + Math.PI / 12) * 110 + y; // scorei的Y坐标
      }
      // for (let i = 0; i <= 4; i++) {
      //   if (i === 1) { // 泪河高度
      //     tempx[i] = s / 100 * Math.cos(1 * 2 * Math.PI / 5 + Math.PI / 10) * score.TearHeight + x// score i的Y坐标
      //     tempy[i] = -s / 100 * Math.sin(1 * 2 * Math.PI / 5 + Math.PI / 10) * score.TearHeight + y + 3// scorei的Y坐标
      //     this.draw(tempx[i], tempy[i], 3, 0, 360, 'blue', 'stroke', exist.TearHeight)
      //   } else if (i === 2) { // 脂质层
      //     tempx[i] = s / 100 * Math.cos(0 * 2 * Math.PI / 5 + Math.PI / 10) * score.LipidLayer + x - 3// score i的Y坐标
      //     tempy[i] = -s / 100 * Math.sin(0 * 2 * Math.PI / 5 + Math.PI / 10) * score.LipidLayer + y// scorei的Y坐标
      //     this.draw(tempx[i], tempy[i], 3, 0, 360, 'blue', 'stroke', exist.LipidLayer)
      //   } else if (i === 3) { // 睑板腺
      //     tempx[i] = s / 100 * Math.cos(4 * 2 * Math.PI / 5 + Math.PI / 10) * score.MeiBomian + x// score i的Y坐标
      //     tempy[i] = -s / 100 * Math.sin(4 * 2 * Math.PI / 5 + Math.PI / 10) * score.MeiBomian + y - 3// scorei的Y坐标
      //     this.draw(tempx[i], tempy[i], 3, 0, 360, 'blue', 'stroke', exist.MeiBomian)
      //   } else if (i === 4) { // 眼红
      //     // alert('4')
      //     tempx[i] = s / 100 * Math.cos(3 * 2 * Math.PI / 5 + Math.PI / 10) * score.EyeRedness + x// score i的Y坐标
      //     tempy[i] = -s / 100 * Math.sin(3 * 2 * Math.PI / 5 + Math.PI / 10) * score.EyeRedness + y - 3// scorei的Y坐标
      //     // this.draw(tempx[i], tempy[i], 3, 0, 360, 'blue', 'stroke', exist[i + 1])
      //     this.draw(tempx[i], tempy[i], 3, 0, 360, 'blue', 'stroke', exist.EyeRedness)
      //   } else if (i === 0) { // Nibut
      //     tempx[i] = s / 100 * Math.cos(2 * 2 * Math.PI / 5 + Math.PI / 10) * score.NIBUT + x + 3// score i的Y坐标
      //     tempy[i] = -s / 100 * Math.sin(2 * 2 * Math.PI / 5 + Math.PI / 10) * score.NIBUT + y// scorei的Y坐标
      //     this.draw(tempx[i], tempy[i], 3, 0, 360, 'blue', 'stroke', exist.NIBUT)
      //   } else {
      //     // tempx[i] = s / 100 * Math.cos(i * 2 * Math.PI / 5 + Math.PI / 10) * score[i] + x + 3// score i的Y坐标
      //     // tempy[i] = -s / 100 * Math.sin(i * 2 * Math.PI / 5 + Math.PI / 10) * score[i] + y// scorei的Y坐标
      //   }
      //   tempxText[i] = s / 100 * Math.cos(i * 2 * Math.PI / 5 + Math.PI / 10) * 110 + x// score i的X坐标
      //   tempyText[i] = -s / 100 * Math.sin(i * 2 * Math.PI / 5 + Math.PI / 10) * 110 + y// scorei的Y坐标
      // }

      this.measureCarambolaText(this.carambolaLanguages, tempxText, tempyText, language);
      // console.log('tempx', tempx)
      this._ctx.moveTo(tempx[0], tempy[0]);
      this._ctx.lineTo(tempx[1], tempy[1]);
      this._ctx.lineTo(tempx[2], tempy[2]);
      this._ctx.lineTo(tempx[3], tempy[3]);
      this._ctx.lineTo(tempx[4], tempy[4]);
      // BUT影藏模块
      this._ctx.lineTo(tempx[5], tempy[5]);
      this._ctx.lineWidth = 1;
      this._ctx.closePath();
      this._ctx.stroke();
    }
  }
  // 绘制背景
  drawBackGround(centerx, centery, size) {
    this._ctx.clearRect(0, 0, this._ctx.width, this._ctx.height);
    // BUT影藏模块
    for (let i = 0; i <= 5; i++) {
      this._ctx.save();
      this._ctx.translate(centerx, centery);
      this._ctx.rotate((2 * i * Math.PI) / 6);
      this._ctx.translate(-centerx, -centery);
      this.drawTriangle(centerx, centery, size);
      this._ctx.restore();
    }
    // for (let i = 0; i <= 4; i++) {
    //   this._ctx.save()
    //   this._ctx.translate(centerx, centery)
    //   this._ctx.rotate(2 * i * Math.PI / 5)
    //   this._ctx.translate(-centerx, -centery)
    //   this.drawTriangle(centerx, centery, size)
    //   this._ctx.restore()
    // }
  }
  drawTriangle(x, y, s) {
    this._ctx.beginPath();
    // BUT影藏模块
    let height = s * Math.cos(Math.PI / 6); // 计算等腰三角形的高
    let width = 2 * s * Math.sin(Math.PI / 6); // 计算等腰三角形的底边长
    // let height = s * Math.cos(Math.PI / 5)// 计算等腰三角形的高
    // let width = 2 * s * Math.sin(Math.PI / 5) // 计算等腰三角形的底边长
    this._ctx.moveTo(x, y); // 从中心点开始
    this._ctx.lineTo(x - width / 2, y + height);
    this._ctx.lineTo(x + width / 2, y + height);
    let grd = this._ctx.createLinearGradient(x - width / 2, y, x - width / 2, y + height); // 使用渐变颜色填充（上到下）
    grd.addColorStop(0, "#ec0a0a"); // 起始颜色
    grd.addColorStop(0.6, "#e5ff00"); // 中间颜色
    grd.addColorStop(1, "green"); // 终点颜色
    this._ctx.fillStyle = grd; // 以上面定义的渐变填充
    this._ctx.fill(); // 闭合形状并且以填充方式绘制出来
  }
  createMockdata() {
    let dataMock = [];
    for (let id = 0; id < 25; id++) {
      let data1 = [];
      for (let ix = 0; ix < 16; ix++) {
        let val = Math.random(Math.random()) * 30;
        data1.push(val);
      }
      dataMock.push(data1);
    }
    return dataMock;
  }
  testCenter(color) {
    let c = color || "white";
    this._ctx.beginPath();
    this._ctx.strokeStyle = c;
    this._ctx.moveTo(0, -this._circleRect.width);
    this._ctx.lineTo(0, this._circleRect.width);
    this._ctx.stroke();
    this._ctx.beginPath();
    this._ctx.moveTo(-this._circleRect.width, 0);
    this._ctx.lineTo(this._circleRect.width, 0);
    this._ctx.stroke();
  }
  clear() {
    this._ctx.restore("clear");
    this._ctx.clearRect(0, 0, this._size.width, this._size.height);
    this._ctx.save("clear");
    // this._translate()
  }
  _translate() {
    this._ctx.translate(this._circleRect.center.x, this._circleRect.center.y);
  }

  _calcCircleRect() {
    let width = this._size.width > this._size.height ? this._size.height : this._size.width;
    return {
      width: width,
      center: {
        x: (this._size.width - width) / 2.0 + width / 2,
        y: (this._size.height - width) / 2.0 + width / 2
      }
    };
  }
  _calcCircle() {
    return {
      r: Math.abs(this._circleRect.width / 2 - 2 * this._padding.left),
      center: {
        x: this._circleRect.center.x,
        y: this._circleRect.center.y
      }
    };
  }
  /**
   * 绘制大圆
   */
  _drawCircle() {
    this._ctx.translate(this._canvas.width / 2, this._canvas.height / 2);
    this._ctx.save();

    this._ctx.beginPath();

    this._ctx.arc(0, 0, this._circle.r, 0, Math.PI * 2);
    this._ctx.stroke();
    this._ctx.restore("translate");
    this._drawCicleTick();
  }
  _measureText(str) {
    let w = this._ctx.measureText(str || "X").width;
    let h = this._ctx.measureText("Z").width;
    return {
      width: w,
      height: h
    };
  }
  _dataInMap(v, isY = false) {
    return isY ? -1 * v * this._scale : v * this._scale;
  }
  _drawXYAxis() {
    this._ctx.save("translate");
    // this.testCenter()
    let scaleSize = 5;
    let size = this._measureText("0");
    let w = size.width;
    let h = size.height;
    let offset = 15;
    let xAxisTop = this._circle.r + 5 + offset;
    this._ctx.beginPath();
    this._ctx.moveTo(-this._circle.r, this._circle.r + 25);
    this._ctx.lineTo(this._circle.r, this._circle.r + 25);
    this._ctx.stroke();
    this._ctx.font = "13px Arial";
    this._ctx.beginPath();
    this._ctx.moveTo(0, xAxisTop);
    this._ctx.lineTo(0, xAxisTop + scaleSize);
    this._ctx.fillText("0", 0 - w / 2, xAxisTop + scaleSize + h * 2 + 3);
    this._ctx.stroke();
    for (let id = 1; id <= this._realDiameter / 2; id++) {
      this._ctx.beginPath();
      this._ctx.moveTo(this._dataInMap(id), xAxisTop);
      this._ctx.lineTo(this._dataInMap(id), xAxisTop + scaleSize);
      let text = id.toString();
      w = this._measureText(text).width;
      this._ctx.fillText(text, this._dataInMap(id) - w / 2, xAxisTop + scaleSize + h * 2 + 3);
      this._ctx.stroke();
      this._ctx.beginPath();
      this._ctx.moveTo(this._dataInMap(id, true), xAxisTop);
      this._ctx.lineTo(this._dataInMap(id, true), xAxisTop + scaleSize);
      this._ctx.fillText(text, this._dataInMap(id, true) - w / 2, xAxisTop + scaleSize + h * 2 + 3);
      this._ctx.stroke();
    }
    this._ctx.restore("translate");
  }
  _getColor(v) {
    let index = parseInt(v / 1.5);
    return NIBUTCOLORS[index] ? NIBUTCOLORS[index] : "white";
  }
  _drawData() {
    this._ctx.save("translate");
    let rsplit = (4 / (this._circlecnt / 2)) * this._scale;

    this._ctx.lineWidth = rsplit;

    for (let ix = this.data.length - 1; ix >= 0; ix--) {
      for (let iy = this.data[ix].length - 1; iy >= 0; iy--) {
        let color = this._getColor(this.data[ix][iy]);
        this._ctx.fillStyle = color;
        this._ctx.beginPath();
        this._ctx.moveTo(0, 0);
        this._ctx.arc(
          0,
          0,
          (ix + 1) * rsplit,
          ((22.5 * iy) / 180) * Math.PI,
          ((22.5 * (iy + 1)) / 180) * Math.PI,
          false
        );
        this._ctx.fill();
      }
    }
    this._ctx.beginPath();
    this._ctx.arc(0, 0, rsplit - 5, 0, Math.PI * 2);
    this._ctx.fillStyle = "black";
    this._ctx.fill();
    this._ctx.restore("translate");
  }
  _drawGrid() {
    let rsplit = 4 / (this._circlecnt / 2);
    this._ctx.strokeStyle = "gray";
    this._ctx.save("translate");
    this._ctx.lineWidth = 0.5;
    for (let id = 1; id <= this._circlecnt / 2; id++) {
      this._ctx.beginPath();
      this._ctx.arc(0, 0, rsplit * id * this._scale, 0, Math.PI * 2);
      this._ctx.stroke();
    }
    this._ctx.restore("translate");
  }
  _drawCicleTick() {
    let w = this._measureText("").width;
    this._ctx.save("translate");
    this._ctx.rotate(0.5 * Math.PI);
    this._ctx.font = "18px Arial";
    this._ctx.strokeStyle = "gray";
    this._ctx.lineWidth = 0.3;
    for (let id = 0; id < 360; id += 22.5) {
      this._ctx.beginPath();
      if (parseInt(id * 10) % 450 === 0) {
        w = this._measureText(id + "°").width;
        this._ctx.fillText(id + "°", -w / 2, -this._circle.r - 8);
      }
      this._ctx.moveTo(0, -this._circle.r);
      this._ctx.lineTo(0, -this._circle.r - 5);
      this._ctx.stroke();
      this._ctx.moveTo(0, 0);
      this._ctx.lineTo(0, -this._circle.r);
      this._ctx.stroke();
      this._ctx.rotate((-22.5 * Math.PI) / 180);
    }
    this._ctx.restore("translate");
    this._drawGrid();
  }
}
export default Drawcanvas;



// WEBPACK FOOTER //
// ./src/dryeye/js/drawReportCanvas.js